import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function chartKpiLabel(theme: Theme): ComponentStyle {
  return {
    componentName: 'chartKpiLabel',
    baseStyle: {
      color: theme.colors.muted
    }
  };
}
